
import Vue, {PropOptions} from 'vue'
import {OrderItemInterface} from "~/store/orderItem";

export default Vue.extend({
  name: 'orderItem',
  props: {
    orderItem: {
      type: Object,
      required: true
    } as PropOptions<OrderItemInterface>
  },
  computed: {
    formatName() {
      // @ts-ignore
      if (this.orderItem.type === 'arrangement') {
        return 'Arrangement';
      }

      // @ts-ignore
      return this.orderItem.name;
    }
  }
})
